// @flow
import type { Decimal, Fx } from './types';

export function getFxRate(fx: Fx): Decimal {
  return fx.rate;
}
